var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.219,
    height: 17.242,
    viewBox: "0 0 20.219 17.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6862",
    "data-name": "Path 6862",
    d: "M2.25,18.179A57.662,57.662,0,0,1,17.414,20.2a1.1,1.1,0,0,0,1.395-1.052v-.965M3.69,4.5v.72a.72.72,0,0,1-.72.72H2.25m0,0V5.58A1.08,1.08,0,0,1,3.33,4.5h16.2M2.25,5.94v8.639M19.528,4.5v.72a.72.72,0,0,0,.72.72h.72M19.528,4.5h.36a1.08,1.08,0,0,1,1.08,1.08v9.359a1.08,1.08,0,0,1-1.08,1.08h-.36m1.44-1.44h-.72a.72.72,0,0,0-.72.72v.72m0,0H3.69m0,0H3.33a1.08,1.08,0,0,1-1.08-1.08v-.36m1.44,1.44V15.3a.72.72,0,0,0-.72-.72H2.25m12.239-4.32a2.88,2.88,0,1,1-2.88-2.88A2.88,2.88,0,0,1,14.489,10.259Zm2.88,0h.008v.008h-.008Zm-11.519,0h.008v.008H5.85Z",
    transform: "translate(-1.499 -3.75)",
    fill: "none",
    stroke: "#24dcae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.f6a5a45e.svg";
export { ForwardRef as ReactComponent };